import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import KnowledgeBuilderContainer from 'builder/Knowledge/containers/KnowledgeBuilderContainer';
import KnowledgePage from './components/KnowledgePage';

const Knowledge = () => (
  <Switch>
    <Route exact path="/knowledge" component={KnowledgePage} />
    <Route path="/knowledge/:documentId" component={KnowledgeBuilderContainer} />
    <Redirect to="/" />
  </Switch>
);

export default Knowledge;
